var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"batch-audit"},[_c('Grid',{ref:"gridEl",attrs:{"grid-key":"batch-summary-audit","columnDefs":_vm.columnDefs,"rowData":_vm.rowData,"main-grid-height":_vm.gridHeight},on:{"grid-ready":_vm.onGridReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }